/**
 * Modal element IDs used throughout Patchwerk
 * Centralizes modal references for maintainability
 */

export const MODAL_IDS = {
    // Profile & Account
    PROFILE_SETTINGS: 'profile-settings-modal',
    DELETE_ACCOUNT: 'delete-account-modal',
    
    // Migration
    MIGRATION: 'migration-modal',
    
    // Patch management
    SAVE_VERSION: 'save-version-modal',
    NEW_PATCH: 'new-patch-modal',
    SAVE_AS: 'save-as-modal',
    PATCH_SETTINGS: 'patch-settings-modal',
    VERSION_HISTORY: 'version-history-modal',
    
    // Device editing
    DEVICE: 'device-modal',
    INSTANCE_LAYOUT: 'instance-layout-modal',
    
    // Storage
    SAVE_STORAGE: 'save-storage-modal',
    OPEN_STORAGE: 'open-storage-modal',
    
    // Clipboard & sharing
    CLIPBOARD: 'clipboard-modal',
    SHARE_STRING: 'share-string-modal'
};
